import React from 'react'
import PageBanner from '../../components/PageBanner'
import PortfolioGlance from '../../components/PortfolioGlance'
import SubHeaderService from '../../components/SubHeaderService'
import ToolTechnology from '../../components/ToolTechnology'
const Smart = () => {
  return (
    <div>
        <PageBanner />
        {/* <ToolTechnology /> */}
        <SubHeaderService />
        <PortfolioGlance/>
    </div>
  )
}

export default Smart
